import React from 'react';
import * as PropTypes from 'prop-types';
import Warning from 'components/Warning';
import Loading from 'components/Loading';

export default function DataStatusWrapper({ isLoading, isError, children }) {
  if (isError) {
    return <Warning />;
  } else if (isLoading) {
    return (
      <div className="loading-container loading-container__big">
        <Loading />
      </div>
    );
  } else {
    return children;
  }
}

DataStatusWrapper.propTypes = {
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
